module.exports = __webpack_public_path__ + "img/forbidden.09551e86.svg";